var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isLoading
      ? _c("div", { staticClass: "campaign-card-wrapper bg-black" })
      : this.campaignExist
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "campaign-card-wrapper",
              style: _vm.backgroundStyle
            },
            [
              _c("div", { staticClass: "campaign-container container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-xl-7 pb-4" }, [
                    _c("div", { staticClass: "campaign-title pb-4" }, [
                      _vm._v(_vm._s(this.bannerTitle))
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "campaign-btn",
                          on: { click: _vm.navigateToCampaignPost }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                this.bannerLink
                                  ? this.bannerLink.description
                                  : ""
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ])
      : _c("div", [
          _c(
            "div",
            {
              staticClass: "campaign-card-wrapper",
              style: _vm.backgroundStyle
            },
            [
              _c("div", { staticClass: "campaign-container container" }, [
                _c(
                  "div",
                  {
                    staticClass: "campaign-title d-flex justify-content-center"
                  },
                  [_c("div", [_vm._v(_vm._s(_vm.homepageHeaderGreeting))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "greeting text-center justify-content-center"
                  },
                  [
                    _c("div", [
                      _vm._v(
                        " " + _vm._s(_vm.CONSTANTS.HOMEPAGE_GENERIC_GREETING)
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1014fc7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1014fc7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/CampaignCard.vue
// module id = null
// module chunks = 